import React from "react";
import { Button, Tooltip } from "@mantine/core";

import { DeleteIcon } from "@piqnt/runtime-core/react/Icon";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

interface EditControlComponentProps {
  emit: EmitFunction;
  enable: boolean;
}

const DeleteControlComponent = React.memo(
  (props: EditControlComponentProps) => {
    const { emit, enable } = props;

    const onRemoveSelection = React.useCallback(() => {
      emit("selection-remove");
    }, [emit]);

    return (
      <>
        <Tooltip label="Delete" position="bottom-start">
          <Button
            onClick={onRemoveSelection}
            title="Delete"
            variant="toolbar"
            disabled={!enable}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  },
);

export const DeleteControl = () => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const enable =
    context.multiselect.value.selected.length && context.editable.value;

  return <DeleteControlComponent emit={emit} enable={enable} />;
};
